<div class="toggle-button">
  <div class="action-button" (click)="lockdown()"
       [ngClass]="{'disabled': (isLocking || isUnlocking), 'enabled': itemStatus === status.Unlocked , 'clicked': itemStatus === status.Locked}">
    <span>
      <app-output-locking-status [showOnlyIcons]="true" [status]="status.Locked"></app-output-locking-status>
    </span>
    <span *ngIf="isLocking; else notLocking">Locking Down</span>
    <ng-template #notLocking>
      <span *ngIf="itemStatus === status.Unlocked">Lock Down</span>
      <span *ngIf="itemStatus === status.Locked">Locked Down</span>
    </ng-template>
  </div>
  <div class="action-button" (click)="release()"
       [ngClass]="{'disabled': (isLocking || isUnlocking), 'enabled': itemStatus === status.Locked, 'clicked': itemStatus === status.Unlocked}">
    <span>
      <app-output-locking-status [showOnlyIcons]="true" [status]="status.Unlocked"></app-output-locking-status>
    </span>
    <span *ngIf="isUnlocking; else notUnlocking">Releasing</span>
    <ng-template #notUnlocking>
      <span *ngIf="itemStatus === status.Unlocked">Released</span>
      <span *ngIf="itemStatus === status.Locked">Release</span>
    </ng-template>
  </div>
</div>

<div>{{(command$ | async).message}}</div>
